(function () {
  const prodSlider = () => {
    $(".product-own-slider-section").each(function () {
      if ($(this).hasClass("slider_started")) {
        return "";
      }

      $(this).addClass("slider_started");
      const id = $(this).attr("id");

      let prodSliderSwiperParams = {
        centeredSlides: false,
        slidesPerView: 1,
        autoHeight: false,
        calculateHeight: false,
        waitForTransition: false,
        watchSlidesProgress: false,
        updateOnWindowResize: true,
        preloadImages: false,
        spaceBetween: 4,
        allowTouchMove: true,
      };
      const swiperRightImg = new Swiper(`#${id} .product-slider__right-block`, {
        ...prodSliderSwiperParams,
        autoplay: false,
        // allowTouchMove: false,
      });
      const prodSlider = new Swiper(`#${id} .swiper-product-slider`, {
        navigation: {
          nextEl: `#${id} .swiper-button-next__prod-slider`,
          prevEl: `#${id} .swiper-button-prev__prod-slider`,
        },
        pagination: {
          el: `#${id} .swiper-pagination`,
          clickable: true,
        },
        ...prodSliderSwiperParams,
      });
      swiperRightImg.controller.control = prodSlider;
      prodSlider.controller.control = swiperRightImg;
      colorScheme(prodSlider);
      prodSlider.on("beforeTransitionStart", function () {
        colorScheme(this);
      });
      function colorScheme(context) {
        const activeIndex = context.activeIndex;
        const activeSlide = context.slides[activeIndex];
        const changeItems = [
          context.navigation.nextEl,
          context.navigation.prevEl,
          context.pagination.el,
        ];
        const colorScheme = $(activeSlide).data("color-scheme");
        changeItems.forEach((item) => {
          $(item)
            .removeClass("color-background-1")
            .removeClass("color-background-4")
            .addClass(colorScheme);
        });
      }
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    prodSlider();
  });

  document.addEventListener("shopify:section:load", function () {
    prodSlider();
  });

  prodSlider();
})();

//button-with-underline

(function () {
  const SECTION_SELECTOR = ".product-own-slider-section";
  const TRIGGER_SELECTOR = "[data-underline-cursor-trigger]";
  const CURSOR_MIN_WIDTH = 991;
  const CURSOR_OFFSET_Y = 30;

  let activeCursor = null;

  const followMouseSlider = (event) => {
    if (!activeCursor) return;

    activeCursor.style.left = event.pageX + "px";
    activeCursor.style.top = event.pageY + CURSOR_OFFSET_Y + "px";
  };

  const hideCursor = () => {
    if (!activeCursor) return;

    activeCursor.style.display = "";
    activeCursor = null;
    document.removeEventListener("pointermove", followMouseSlider);
  };

  const showCursor = (cursor, event) => {
    if (activeCursor === cursor) return;

    hideCursor();
    activeCursor = cursor;
    cursor.style.display = "block";
    followMouseSlider(event);
    document.addEventListener("pointermove", followMouseSlider);
  };

  const bindTrigger = (trigger, section) => {
    if (trigger.dataset.underlineCursorBound === "true") return;

    const index = trigger.dataset.underlineCursorIndex;
    if (index === undefined) return;

    const cursor = section.querySelector(
      `[data-underline-cursor][data-underline-cursor-index="${index}"]`
    );
    if (!cursor) return;

    trigger.dataset.underlineCursorBound = "true";

    trigger.addEventListener("pointerenter", (event) => {
      if (event.pointerType === "touch") return;
      if (window.innerWidth < CURSOR_MIN_WIDTH) return;

      showCursor(cursor, event);
    });

    trigger.addEventListener("pointerleave", () => {
      if (activeCursor !== cursor) return;

      hideCursor();
    });
  };

  const collectSections = (root) => {
    const sections = [];

    if (root instanceof Element && root.matches(SECTION_SELECTOR)) {
      sections.push(root);
    }

    root.querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      sections.push(section);
    });

    return sections;
  };

  const initUnderlineCursors = (root) => {
    collectSections(root || document).forEach((section) => {
      section.querySelectorAll(TRIGGER_SELECTOR).forEach((trigger) => {
        bindTrigger(trigger, section);
      });
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    initUnderlineCursors();
  });

  document.addEventListener("shopify:section:load", function (event) {
    initUnderlineCursors(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    if (activeCursor && event.target.contains(activeCursor)) {
      hideCursor();
    }
  });

  initUnderlineCursors();
})();